const gbpFull = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 });
const gbpPence = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const intFmt = new Intl.NumberFormat("en-GB");

/** £12,345 (whole pounds). Pass pence=true for £12,345.67. */
export function gbp(n: number | null | undefined, pence = false): string {
  if (n === null || n === undefined || !isFinite(n)) return "—";
  return (pence ? gbpPence : gbpFull).format(n);
}

/** £1.2k, £34k, £1.4m — for dense displays. */
export function gbpShort(n: number | null | undefined): string {
  if (n === null || n === undefined || !isFinite(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `£${(n / 1_000_000).toFixed(abs >= 10_000_000 ? 0 : 1)}m`;
  if (abs >= 10_000) return `£${Math.round(n / 1000)}k`;
  if (abs >= 1_000) return `£${(n / 1000).toFixed(1)}k`;
  return `£${Math.round(n)}`;
}

export function int(n: number | null | undefined): string {
  if (n === null || n === undefined || !isFinite(n)) return "—";
  return intFmt.format(n);
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${int(n)} ${n === 1 ? one : many}`;
}

const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "2026-12-31" → "31 Dec 2026", the same as the web's dates (for timeline and audit text). */
export function fmtDay(isoDate: string): string {
  const [y, m, d] = isoDate.slice(0, 10).split("-").map(Number);
  return `${d} ${MONTHS_SHORT[(m ?? 1) - 1]} ${y}`;
}
